export const countAvailableStock = (data) => {
  let availableStock = 0;
  data?.productStorages?.forEach((storage) => {
    if (typeof storage?.availableStock === 'number') {
      availableStock += storage?.availableStock;
    }
  });
  return availableStock;
};
